export default "__VITE_ASSET__CfofRqAZ__"